import styles from './FormLabel.module.scss';

type Props = {
  children: React.ReactNode;
  required?: boolean;
};

function FormLabel({ children, required = false }: Props) {
  return (
    <div className={styles.componentStyle}>
      {/* biome-ignore lint/a11y/noLabelWithoutControl: <explanation> */}
      <label>
        {children}
        {required && <span className={styles.required}>*</span>}
      </label>
    </div>
  );
}
export default FormLabel;
